export const DEFAULT_PAGE_LIMIT = 10;
export const getRowsPerPage = function getRowsPerPage() {
  let count = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  let pageLimit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DEFAULT_PAGE_LIMIT;
  return count > pageLimit ? pageLimit : Number.POSITIVE_INFINITY;
};